// extracted by mini-css-extract-plugin
export default {"sliderWrapper":"HomeProductsWidget_sliderWrapper__AKVpV"};